import React from 'react';
import { Card } from 'antd';
import styled from 'styled-components';
import Avatar from 'components/AuthorAvatar';
import Link from 'next/link';
import SocialLinks from 'components/SocialLinks';
import { merriweather } from 'styles/GlobalStyle';

const AuthorLink = styled(Link)`
    font-family: ${merriweather.style.fontFamily};
    color: ${(props) => props.color || props.theme.colors.brownishGrey};
    font-weight: 300;
    font-size: 24px;
    word-wrap: break-word;
    white-space: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    :hover {
        color: ${(props) => props.color || props.theme.colors.greyishBrownTwo};
    }
`;

const AuthorAbout = styled.div`
    color: ${(props) => props.color || props.theme.colors.greyishBrown};
    font-weight: 300;
    font-size: 18px;
    font-stretch: normal;
    font-style: normal;
    line-height: 26px;
    letter-spacing: normal;
    text-align: left;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 5; /* number of lines to show */
    -webkit-box-orient: vertical;
`;

const SocialWrapper = styled.div`
    padding: 40px;
    margin-left: 35px;
`;

interface Props {
    author: Author;
}

const AboutAuthorSection = ({ author }: Props) => (
    <Card bordered={false} style={{ boxShadow: 'none' }}>
        <Card.Meta
            avatar={<Avatar author={author} size={92} />}
            title={<AuthorLink href={`/autorzy/${author.seoSlug}`}>{author.name}</AuthorLink>}
            description={
                <AuthorAbout
                    dangerouslySetInnerHTML={{
                        __html: author.about
                    }}
                />
            }
        />
        {Object.values(author.socialLinks).every((x) => x !== null) && (
            <SocialWrapper>
                <SocialLinks {...author.socialLinks} size="18px" />
            </SocialWrapper>
        )}
    </Card>
);

export default AboutAuthorSection;
